import { actions } from './reducer'
// this should only be used with components that are fully migrated to consuming v4 data
// and when the feature_LEARN-24754_educator_journey_updates flag is on
import api from 'lib/api/ssapi/secondStepApi.v4'
import { formatError } from 'utils/formatError'
import { isV4Routed } from 'lib/api/ssapi/secondStepApi.router'

const clearErrors = () => {
  return async dispatch => {
    dispatch(actions.clearErrors())
  }
}

const fetchUserNetSuiteAssets = () => {
  return async dispatch => {
    dispatch(actions.fetchingUserNetSuiteAssets())

    try {
      const { data } = await api.getNetSuiteAssetsForUser()
      dispatch(actions.fetchingUserNetSuiteAssetsSuccess(data))
    } catch (error) {
      dispatch(
        actions.fetchingUserNetSuiteAssetsError({ error: formatError(error) }),
      )
    }
  }
}

const fetchUserSites = () => {
  return async dispatch => {
    dispatch(actions.fetchingUserSites())

    try {
      const { data } = await api.getUserSites()
      dispatch(actions.fetchingUserSitesSuccess(data))
    } catch (error) {
      dispatch(actions.fetchingUserSitesError(formatError(error)))
    }
  }
}

export default {
  clearErrors,
  fetchUserNetSuiteAssets,
  fetchUserSites,
  // New: mutation endpoints for v4
  updateSitePreferences: (siteId, legacyPreferences) => {
    return async (dispatch, getState) => {
      try {
        if (!isV4Routed('updateSitePreferences')) {
          throw new Error('updateSitePreferences not routed to v4')
        }
        const referenceSites = getState()?.ssapiManager?.sites
        const { data } = await api.updateSitePreferences(
          siteId,
          legacyPreferences,
          {
            referenceSites,
          },
        )
        // data expected to be array of all site preferences for that site
        dispatch(
          actions.updateSitePreferences({
            siteId,
            preferences: data.preferences,
          }),
        )
        return data
      } catch (error) {
        throw formatError(error)
      }
    }
  },
  updateSiteUserPreferences: (siteId, legacyPreferences) => {
    return async (dispatch, getState) => {
      try {
        if (!isV4Routed('updateSiteUserPreferences')) {
          throw new Error('updateSiteUserPreferences not routed to v4')
        }
        const referenceSites = getState()?.ssapiManager?.sites
        const { data } = await api.updateSiteUserPreferences(
          siteId,
          legacyPreferences,
          {
            referenceSites,
          },
        )
        // data expected to be array of all site preferences for that site
        dispatch(actions.updateSitePreferences({ siteId, preferences: data }))
        return data
      } catch (error) {
        throw formatError(error)
      }
    }
  },
  updateSitePacingDates: (siteId, programName, pacingUpdate) => {
    return async dispatch => {
      try {
        if (!isV4Routed('updateSitePacingDates')) {
          throw new Error('updateSitePacingDates not routed to v4')
        }
        const { data } = await api.updateSitePacingDates(
          siteId,
          programName,
          pacingUpdate,
        )
        return data
      } catch (error) {
        throw formatError(error)
      }
    }
  },
  updateMspOptInSettings: mspOptInArr => {
    return async dispatch => {
      try {
        const response = await api.updateMspOptInSettings(mspOptInArr)
        return response.data
      } catch (error) {
        throw formatError(error)
      }
    }
  },
}
